import React, { useState, useEffect } from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { businessInfo } from '../mockData';

const StickyBottomBar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Show bar when scrolling up, hide when scrolling down
      if (currentScrollY < lastScrollY || currentScrollY < 100) {
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const handleCall = () => {
    window.location.href = `tel:${businessInfo.phone}`;
  };

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${businessInfo.whatsapp}?text=Hi, I'm interested in your marble polishing services`, '_blank');
  };

  return (
    <div
      data-testid="mobile-sticky-bar"
      className={`md:hidden fixed bottom-0 left-0 right-0 z-50 transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="bg-white border-t-2 border-gray-200 shadow-lg">
        <div className="grid grid-cols-2 gap-0">
          <button
            onClick={handleCall}
            data-testid="mobile-sticky-call-button"
            className="flex items-center justify-center space-x-2 py-4 bg-emerald-600 text-white font-semibold hover:bg-emerald-700 transition-colors active:bg-emerald-800"
          >
            <Phone className="w-5 h-5" />
            <span>Call Now</span>
          </button>
          <button
            onClick={handleWhatsApp}
            data-testid="mobile-sticky-whatsapp-button"
            className="flex items-center justify-center space-x-2 py-4 bg-green-600 text-white font-semibold hover:bg-green-700 transition-colors active:bg-green-800"
          >
            <MessageCircle className="w-5 h-5" />
            <span>WhatsApp</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickyBottomBar;
